import { useEffect, useState } from 'react'
import { NativeScrollEvent, NativeSyntheticEvent } from 'react-native'

const NON_SCREEN_SCROLLER_SELECTOR = '[role="dialog"], [aria-modal="true"], textarea, input'

const isNonScreenScroller = (element: HTMLElement) => Boolean(element.closest(NON_SCREEN_SCROLLER_SELECTOR))

export const useIsScreenScrolled = (): {
  isScrolled: boolean
  handleScroll: ((event: NativeSyntheticEvent<NativeScrollEvent>) => void) | undefined
} => {
  const [isScrolled, setIsScrolled] = useState(false)

  useEffect(() => {
    const handler = (event: Event) => {
      const target = event.target as HTMLElement | Document | null
      // Scrolling inside an overlay or a text field (e.g. the messenger's message list or input) isn't a screen scroll
      if (target instanceof HTMLElement && isNonScreenScroller(target)) return
      let scrollTop = window.scrollY
      if (target instanceof HTMLElement) {
        scrollTop = Math.max(scrollTop, target.scrollTop)
      }
      const scrolled = scrollTop > 0
      setIsScrolled((prev) => (prev !== scrolled ? scrolled : prev))
    }
    window.addEventListener('scroll', handler, { passive: true, capture: true })
    return () => window.removeEventListener('scroll', handler, { capture: true })
  }, [])

  return { isScrolled, handleScroll: undefined }
}
